export const STATUS_QUALIFIED = 'qualified';
export const STATUS_PENDING = 'pending';
export const STATUS_APPLIED = 'applied';
export const STATUS_SHORTLISTED = 'shortlisted';
export const STATUS_INTERVIEW = 'interview';
export const STATUS_OFFER = 'offer';
export const STATUS_HIRED = 'hired';
export const STATUS_DISMISSED = 'dismissed';
